var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNavCalendar = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon__calendar",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.302;enable-background:new    ;}\n\t#icon__calendar .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0066CC;}\n\t#icon__calendar .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#124B84;}\n\t#icon__calendar .st3{fill:#3B6895;}\n\t#icon__calendar .st4{fill:#F9FAFB;}\n\t#icon__calendar .st5{fill:#FCFCFD;}\n\t#icon__calendar .st6{fill:#426D99;}\n\t#icon__calendar .st7{fill:#416D99;}\n\t#icon__calendar .st8{fill:#B2D1F0;}\n\t#icon__calendar .st9{fill:#FDFEFE;}\n\t#icon__calendar .st10{fill:#406C98;}\n\t#icon__calendar .st11{fill:#406C99;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_790_copy_4_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_790_copy_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.9,20.9H4.6c-0.4,0-0.7,0.3-0.7,0.7v36c0,0.4,0.3,0.7,0.7,0.7h52.3c0.4,0,0.7-0.3,0.7-0.7v-36 C57.6,21.2,57.3,20.9,56.9,20.9z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_792_copy_1_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rounded_Rectangle_792_copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.9,9.1H5c-0.4,0-0.7,0.3-0.7,0.7v8.6c0,0.4,0.3,0.7,0.7,0.7h50.9c0.4,0,0.7-0.3,0.7-0.7V9.8 C56.6,9.4,56.3,9.1,55.9,9.1z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "calendar__x28_2_x29__copy_2_xA0_Image_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.2,53.3c0-13.7,0-27.4,0-41c0-0.1,0-0.2,0-0.2c0-0.5,0-1,0-1.4c0.1-0.2,0.2-0.3,0.3-0.5 c1.4-3.4,3.6-4.9,7.2-4.9c0.7,0,1.5,0,2.3,0c0-1.7,0-3.2,0-4.7c1.6,0,3.2,0,4.8,0c0,1.5,0,3.1,0,4.6c10.3,0,20.5,0,30.7,0 c0-1.6,0-3.1,0-4.6c1.6,0,3.2,0,4.8,0c0,1.5,0,3.1,0,4.7c1.1,0,2.1,0,3.1,0c3,0.1,5.4,2,6.4,4.8c0.1,0.3,0.2,0.5,0.4,0.8 c0,14.2,0,28.3,0,42.5c0,0.2,0,0.5,0,0.7c0,0.3,0,0.6,0,1c-0.9,2.4-2.4,4.2-4.8,5.3c-16.8,0-33.6,0-50.4,0 c-1.1-0.8-2.2-1.4-3.1-2.3c-0.8-0.8-1.1-2-1.7-3c0-0.3,0-0.6,0-1C0.2,53.8,0.2,53.5,0.2,53.3z M4.9,22.6c0,0.5,0,0.9,0,1.2 c0,9.6,0,19.3,0,28.9c0,2.3,0.8,3.1,3.1,3.1c14.8,0,29.6,0,44.4,0c2.3,0,3.1-0.7,3.1-3.1c0-9.6,0-19.3,0-28.9 c0-0.4,0-0.8-0.1-1.2C38.6,22.6,21.8,22.6,4.9,22.6z M45.7,9.9c-10.4,0-20.6,0-30.9,0c0,1.6,0,3,0,4.5c-1.6,0-3.1,0-4.7,0 c0-1.6,0-3,0-4.6C9,9.9,8,9.8,7,9.9c-1,0.1-1.9,0.7-1.9,1.7c-0.1,2,0,4.1,0,6.2c16.9,0,33.6,0,50.5,0c0-1.9,0-3.8,0-5.7 c0-1.2-0.9-2.1-2.2-2.2c-0.9-0.1-1.9,0-3,0c0,1.6,0,3.1,0,4.6c-1.6,0-3.1,0-4.7,0C45.7,12.9,45.7,11.5,45.7,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M45.6,0.5c0,1.5,0,3,0,4.6c-10.2,0-20.4,0-30.7,0c0-1.5,0-3.1,0-4.6C25.1,0.5,35.4,0.5,45.6,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.2,10.8c-0.1-0.3-0.3-0.5-0.4-0.8c-1-2.8-3.4-4.6-6.4-4.8c-1,0-2,0-3.1,0c0-1.6,0-3.2,0-4.7 c3.3,0,6.6,0,9.8,0C60.2,3.9,60.2,7.4,60.2,10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M10.1,0.5c0,1.5,0,3,0,4.7c-0.8,0-1.6,0-2.3,0c-3.6,0-5.9,1.6-7.2,4.9c-0.1,0.2-0.2,0.3-0.3,0.5 c0-3.4,0-6.7,0-10.1C3.5,0.5,6.8,0.5,10.1,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M0.2,55c0.5,1,0.9,2.1,1.7,3C2.8,58.8,4,59.5,5,60.2c-1.6,0-3.2,0-4.8,0C0.2,58.5,0.2,56.7,0.2,55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.4,60.2c2.4-1,3.9-2.9,4.8-5.3c0,1.8,0,3.5,0,5.3C58.6,60.2,57,60.2,55.4,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0.2,53.3c0,0.2,0,0.5,0,0.7C0.2,53.8,0.2,53.5,0.2,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M60.2,54c0-0.2,0-0.5,0-0.7C60.2,53.5,60.2,53.8,60.2,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0.2,12c0,0.1,0,0.2,0,0.2C0.2,12.2,0.2,12.1,0.2,12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M4.9,22.6c16.9,0,33.7,0,50.5,0c0,0.4,0.1,0.8,0.1,1.2c0,9.6,0,19.3,0,28.9c0,2.3-0.8,3.1-3.1,3.1 c-14.8,0-29.6,0-44.4,0c-2.4,0-3.1-0.7-3.1-3.1c0-9.6,0-19.3,0-28.9C4.9,23.5,4.9,23.1,4.9,22.6z M9.2,27.5c0,1.6,0,3.1,0,4.6 c1.6,0,3.1,0,4.6,0c0-1.6,0-3.1,0-4.6C12.2,27.5,10.8,27.5,9.2,27.5z M18.6,32c1.6,0,3.1,0,4.6,0c0-1.6,0-3,0-4.5 c-1.6,0-3.1,0-4.6,0C18.6,29.1,18.6,30.5,18.6,32z M27.9,32.1c1.6,0,3.1,0,4.6,0c0-1.6,0-3.1,0-4.6c-1.6,0-3.1,0-4.6,0 C27.9,29,27.9,30.5,27.9,32.1z M37.3,27.5c0,1.6,0,3.1,0,4.6c1.6,0,3.1,0,4.5,0c0-1.6,0-3.1,0-4.6C40.3,27.5,38.9,27.5,37.3,27.5 z M46.7,32c1.6,0,3.1,0,4.6,0c0-1.6,0-3,0-4.5c-1.6,0-3.1,0-4.6,0C46.7,29.1,46.7,30.5,46.7,32z M9.2,41.4c1.6,0,3.1,0,4.6,0 c0-1.6,0-3.1,0-4.6c-1.6,0-3.1,0-4.6,0C9.2,38.4,9.2,39.9,9.2,41.4z M23.2,41.5c0-1.6,0-3.1,0-4.6c-1.6,0-3.1,0-4.6,0 c0,1.6,0,3.1,0,4.6C20.1,41.5,21.6,41.5,23.2,41.5z M27.9,41.4c1.6,0,3.1,0,4.6,0c0-1.6,0-3.1,0-4.6c-1.6,0-3.1,0-4.6,0 C27.9,38.4,27.9,39.9,27.9,41.4z M37.3,41.4c1.6,0,3.1,0,4.6,0c0-1.6,0-3,0-4.5c-1.6,0-3.1,0-4.6,0 C37.3,38.4,37.3,39.9,37.3,41.4z M46.7,36.8c0,1.6,0,3.1,0,4.6c1.6,0,3.1,0,4.6,0c0-1.6,0-3.1,0-4.6 C49.7,36.8,48.3,36.8,46.7,36.8z M13.8,50.8c0-1.5,0-3,0-4.5c-1.6,0-3.1,0-4.6,0c0,1.6,0,3,0,4.5C10.7,50.8,12.2,50.8,13.8,50.8z  M18.5,50.8c1.6,0,3.1,0,4.6,0c0-1.5,0-3,0-4.5c-1.6,0-3.1,0-4.6,0C18.5,47.8,18.5,49.2,18.5,50.8z M32.6,50.8c0-1.6,0-3,0-4.5 c-1.6,0-3.1,0-4.6,0c0,1.6,0,3,0,4.5C29.5,50.8,31,50.8,32.6,50.8z M42,46.3c-1.6,0-3.1,0-4.6,0c0,1.6,0,3,0,4.5 c1.6,0,3.1,0,4.6,0C42,49.2,42,47.8,42,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M45.7,9.9c0,1.6,0,3,0,4.5c1.6,0,3.1,0,4.7,0c0-1.5,0-3,0-4.6c1.1,0,2,0,3,0c1.2,0.1,2.1,0.9,2.2,2.2 c0.1,1.9,0,3.7,0,5.7c-16.8,0-33.6,0-50.5,0c0-2-0.1-4.1,0-6.2C5.1,10.6,6,10,7,9.9c1-0.1,2,0,3.1,0c0,1.6,0,3,0,4.6 c1.6,0,3.1,0,4.7,0c0-1.5,0-3,0-4.5C25.1,9.9,35.3,9.9,45.7,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M9.2,27.5c1.6,0,3,0,4.6,0c0,1.5,0,3,0,4.6c-1.5,0-3,0-4.6,0C9.2,30.5,9.2,29.1,9.2,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M18.6,32c0-1.5,0-3,0-4.5c1.5,0,3,0,4.6,0c0,1.5,0,3,0,4.5C21.7,32,20.1,32,18.6,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.9,32.1c0-1.6,0-3,0-4.6c1.5,0,3,0,4.6,0c0,1.5,0,3,0,4.6C31,32.1,29.5,32.1,27.9,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M37.3,27.5c1.5,0,3,0,4.5,0c0,1.5,0,3,0,4.6c-1.5,0-3,0-4.5,0C37.3,30.6,37.3,29.1,37.3,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M46.7,32c0-1.5,0-3,0-4.5c1.5,0,3.1,0,4.6,0c0,1.5,0,3,0,4.5C49.8,32,48.3,32,46.7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M9.2,41.4c0-1.5,0-3,0-4.6c1.5,0,3,0,4.6,0c0,1.5,0,3,0,4.6C12.3,41.4,10.8,41.4,9.2,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.2,41.5c-1.6,0-3,0-4.6,0c0-1.5,0-3,0-4.6c1.5,0,3,0,4.6,0C23.2,38.4,23.2,39.9,23.2,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M27.9,41.4c0-1.5,0-3,0-4.6c1.5,0,3,0,4.6,0c0,1.5,0,3,0,4.6C31,41.4,29.5,41.4,27.9,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M37.3,41.4c0-1.5,0-3,0-4.5c1.5,0,3.1,0,4.6,0c0,1.5,0,3,0,4.5C40.4,41.4,38.9,41.4,37.3,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M46.7,36.8c1.6,0,3,0,4.6,0c0,1.5,0,3,0,4.6c-1.5,0-3,0-4.6,0C46.7,39.9,46.7,38.5,46.7,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M13.8,50.8c-1.6,0-3,0-4.6,0c0-1.5,0-3,0-4.5c1.5,0,3,0,4.6,0C13.8,47.8,13.8,49.3,13.8,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M18.5,50.8c0-1.6,0-3,0-4.5c1.5,0,3.1,0,4.6,0c0,1.5,0,3,0,4.5C21.6,50.8,20.1,50.8,18.5,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M32.6,50.8c-1.6,0-3.1,0-4.6,0c0-1.5,0-3,0-4.5c1.5,0,3,0,4.6,0C32.6,47.8,32.6,49.2,32.6,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M42,46.3c0,1.5,0,3,0,4.5c-1.5,0-3,0-4.6,0c0-1.5,0-2.9,0-4.5C38.8,46.3,40.3,46.3,42,46.3z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNavCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nav_calendar.99c340e1.svg";
export { ForwardRef as ReactComponent };